import { currentWeek } from './weekMath';
import type { IsoWeek } from './weekMath';

const KEY = 'rd-last-week';

/** The week a panel or the timetable returns to; the week view records it. */
export function rememberWeek(week: IsoWeek): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(week));
  } catch {
    // Not remembered; "back" then means this week.
  }
}

export function lastWeek(): IsoWeek {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(KEY) ?? 'null') as Partial<IsoWeek> | null;
    if (parsed && Number.isInteger(parsed.year) && Number.isInteger(parsed.week)) {
      return { year: parsed.year as number, week: parsed.week as number };
    }
  } catch {
    // Corrupt value: fall through.
  }
  return currentWeek();
}
